import { apiHelper } from '@/utils/api.helper'
import { uiHelper } from '@/utils//ui.helper'

export const AUTH = {
  login,
  register,
  getProfile,
  editProfile,
  checkCurrentPassword,
  changePassword,
  getAddress,
  getAddressDetail,
  addAddress,
  editAddress,
  deleteAddress,
  enablePushNotification,
  registerReferral,
  getPoint,
  getVoucher,
  logout,
  registerDeviceToken,
  downloadPointPDF,
  getPointTransferMemberList,
  transferPoint,
  getShareAndRewards
}

const URL = {
  ACCOUNT: 'account',
  REGISTER: 'register',
  LOGIN: 'login',
  PROFILE: 'profile',
  EDIT_PROFILE: 'editprofile',
  CHECK_CURRENT_PASSWORD: 'checkcurrentpassword',
  CHANGE_PASSWORD: 'changepassword',
  ADDRESS: 'address',
  GET_ADDRESS_DETAILS: 'getaddressdetails',
  NEW_ADDRESS: 'newaddress',
  EDIT_ADDRESS: 'editaddress',
  DELETE_ADDRESS: 'deleteaddress',
  ENABLE_PUSH_NOTIFICATION: 'enable_push_notification',
  REGISTER_REFERRAL: 'register-referral',
  POINT: 'point',
  VOUCHER: 'voucher',
  LOGOUT: 'logout',
  REGISTER_DEVICE_TOKEN: 'register_devicetoken',
  MEMBER_LIST: 'memberlist',
  TRANSFER_POINT: 'transferpoint',
  SHARE_AND_REWARDS: 'shareandrewards'
}

function login({ countryId, mobileNumber, password }) {
  let requestBody = {
    country_id: countryId,
    mobile: mobileNumber,
    password: password,
    device_token: uiHelper.getLocalStorage('deviceToken'),
    os_type: 'web'
  }
  return apiHelper(false).post(`${URL.ACCOUNT}/${URL.LOGIN}`, null, {
    params: requestBody
  })
}

function register(form) {
  let requestBody = {
    name: form.name,
    email: form.email,
    country_id: form.mobileNumber.country_id,
    mobile: form.mobileNumber.mobile,
    password: form.newPassword,
    password_confirmation: form.confirmPassword,
    referral_code: form.referralCode,
    birthday: form.birthday,
    gender: form.gender,
    device_token: uiHelper.getLocalStorage('deviceToken'),
    os_type: 'web'
  }

  return apiHelper(false).post(`${URL.ACCOUNT}/${URL.REGISTER}`, null, {
    params: requestBody
  })
}

function getProfile() {
  return apiHelper().get(`${URL.ACCOUNT}/${URL.PROFILE}`)
}

function editProfile(form) {
  return apiHelper().put(`${URL.ACCOUNT}/${URL.EDIT_PROFILE}`, null, {
    params: form
  })
}

function checkCurrentPassword(form) {
  return apiHelper().post(`${URL.ACCOUNT}/${URL.CHECK_CURRENT_PASSWORD}`, null, {
    params: form
  })
}

function changePassword(form) {
  return apiHelper().put(`${URL.ACCOUNT}/${URL.CHANGE_PASSWORD}`, null, {
    params: form
  })
}

function getAddress() {
  return apiHelper().get(`${URL.ACCOUNT}/${URL.ADDRESS}`)
}

function getAddressDetail(id) {
  return apiHelper().get(`${URL.ACCOUNT}/${URL.GET_ADDRESS_DETAILS}/${id}`)
}

function addAddress(form) {
  return apiHelper().post(`${URL.ACCOUNT}/${URL.NEW_ADDRESS}`, null, {
    params: form
  })
}

function editAddress(id, form) {
  return apiHelper().put(`${URL.ACCOUNT}/${URL.EDIT_ADDRESS}/${id}`, null, {
    params: form
  })
}

function deleteAddress(id) {
  return apiHelper().delete(`${URL.ACCOUNT}/${URL.DELETE_ADDRESS}/${id}`)
}

function enablePushNotification(form) {
  return apiHelper().post(`${URL.ACCOUNT}/${URL.ENABLE_PUSH_NOTIFICATION}`, null, {
    params: form
  })
}

function registerReferral(form) {
  let requestBody = {
    name: form.name,
    email: form.email,
    country_id: form.mobileNumber.country_id,
    birthday: form.birthday,
    gender: form.gender,
    mobile: form.mobileNumber.mobile,
    password: form.newPassword,
    password_confirmation: form.confirmPassword,
    referral_code: form.referralCode,
    device_token: uiHelper.getLocalStorage('deviceToken'),
    os_type: 'web'
  }

  return apiHelper(false).post(`${URL.ACCOUNT}/${URL.REGISTER_REFERRAL}`, null, {
    params: requestBody
  })
}

function getPoint(params) {
  return apiHelper().get(`${URL.ACCOUNT}/${URL.POINT}`, { params })
}

function getVoucher(params) {
  return apiHelper().get(`${URL.ACCOUNT}/${URL.VOUCHER}`, { params })
}

function getShareAndRewards(params) {
  return apiHelper().get(`${URL.ACCOUNT}/${URL.SHARE_AND_REWARDS}`)
}

function logout() {
  let requestBody = {
    device_token: uiHelper.getLocalStorage('deviceToken'),
    os_type: 'web'
  }
  return apiHelper().post(`${URL.ACCOUNT}/${URL.LOGOUT}`, null, {
    params: requestBody
  })
}

function registerDeviceToken(deviceToken) {
  let requestBody = {
    device_token: deviceToken,
    os_type: 'web'
  }
  return apiHelper().post(`${URL.ACCOUNT}/${URL.REGISTER_DEVICE_TOKEN}`, null, {
    params: requestBody
  })
}

function downloadPointPDF(params) {
  return apiHelper().get(`${URL.ACCOUNT}/${URL.POINT}`, { params, responseType: 'blob' })
}

function getPointTransferMemberList(params) {
  return apiHelper().get(`${URL.ACCOUNT}/${URL.MEMBER_LIST}`, { params })
}

function transferPoint(params) {
  return apiHelper().post(`${URL.ACCOUNT}/${URL.TRANSFER_POINT}`, null, { params })
}
